import { UsersTenantUpdateDto } from "@o2-fe/api";
import { TenantFormValues } from "../interfaces/tenant-form.interface";

/**
 * Maps tenant form values to UpdateTenantDto
 */
export const mapTenantFormToUpdateDto = (
  formValues: TenantFormValues,
): UsersTenantUpdateDto => {
  // Collect the four threshold inputs into the array the backend expects,
  // dropping empty slots and de-duplicating (the backend rejects duplicates
  // via @ArrayUnique, and two equal thresholds are meaningless). When none are
  // set, send null to clear all.
  const configuredThresholds = [
    formValues.budgetThreshold1,
    formValues.budgetThreshold2,
    formValues.budgetThreshold3,
    formValues.budgetThreshold4,
  ].filter((value): value is number => value != null);
  const uniqueThresholds = [...new Set(configuredThresholds)];
  const budgetThresholds: number[] | null =
    uniqueThresholds.length === 0 ? null : uniqueThresholds;

  return {
    companyName: formValues.companyName === "" ? null : formValues.companyName,
    email: formValues.email === "" ? null : formValues.email,
    phone: formValues.phone === "" ? null : formValues.phone,
    sdi: formValues.sdi === "" ? null : formValues.sdi,
    vatNumber: formValues.vatNumber === "" ? null : formValues.vatNumber,
    indirectCosts: formValues.indirectCosts,
    margin: formValues.margin,
    billableHourlyRate: formValues.billableHourlyRate,
    inarcassaContribution: formValues.inarcassaContribution,
    sprint: formValues.sprint,
    insuranceCompany:
      formValues.insuranceCompany === "" ? null : formValues.insuranceCompany,
    policyNumber:
      formValues.policyNumber === "" ? null : formValues.policyNumber,
    address: {
      street: formValues.street === "" ? null : formValues.street,
      city: formValues.city === "" ? null : formValues.city,
      province: formValues.province === "" ? null : formValues.province,
      postalCode: formValues.postalCode === "" ? null : formValues.postalCode,
    },
    budgetThresholds,
  };
};
